import { render } from "./AlgoliaCorrectionSearchComponent.vue?vue&type=template&id=b2cb1c5e"
import script from "./AlgoliaCorrectionSearchComponent.vue?vue&type=script&lang=js"
export * from "./AlgoliaCorrectionSearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__